import React, { useEffect, useRef, useState } from "react";
import {
  DeleteOutlined,
  EditOutlined,
  MailOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import "./SaleItemWidget.css";
import { showConfirmDlgWidget } from "components/ConfirmDlgWidget/showConfirmDlgWidget";
import { Col, Row } from "antd";
import ExtraOptionItems from "../ExtraOptionItems/ExtraOptionItems";
import RecipeExtraItems from "../RecipeExtraItems/RecipeExtraItems";
import {
  ComponentToMultiPrint,
  ComponentToPrint,
} from "components/PrintView/PrintView";
import { useReactToPrint } from "react-to-print";
import { showMultiPrintDialog } from "./MultiPrintDialog/showMultiPrintDialog";
import { Checkbox } from "antd";
import type { CheckboxProps } from "antd";
import { validateEmail } from "services/commonService";
import { showSeparatePrintDialog } from "./SeparatePrintDialog/showSeparatePrintDialog";

function SaleItemWidget(props) {
  const componentRef = useRef();
  const componentMultiRef = useRef();

  const [searchList, setSearchList] = useState([]);
  const [multiDataList, setMultiDataList] = useState([]);

  const {
    info,
    approveAction,
    cancelAction,
    deliverAction,
    paymentConfirmAction,
    selectOption,
    type,
    settingData,
    selectedOrderAction,
    emailReceiptConfirmAction,
  } = props;

  const emailStyles = `
  .one-item {
    max-width: 360px;
    border: 1px solid #D9D9D9;
  }
  .item-header {
    background-color: #389b3a;
    padding: 8px 8px;
    color: white;
  }
  .customer-name {
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
    width: 100px;
    text-align: right;
    margin-bottom: 0px;
  }
  .item-body {
    padding: 5px;
    background-color: #fafafa;

  }
  .item-body-bottom {
    margin-top: 3px;
    margin-bottom: 3px;
    width: 100%;
    height: 1px;
    background-color: #bfbfbf;
  }
  .item-name {
    max-width: 320px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .item-note {
    white-space: pre-wrap;
  }
  .btn_order_normal {
    cursor: pointer;
    display: block;
    margin: 2px;
    margin-top: 0px;
    text-transform: uppercase;
    text-align: center;
    width: 99%;
    padding: 9px;
    border-radius: 5px;
    min-height: 40px;
    background-color: rgb(236 79 55);
    color: rgb(255, 255, 255);
    border: 1px solid #D9D9D9;
    font-size: 1em;
  }

  .btn_email_normal {
    cursor: pointer;
    display: block;
    margin: 2px;
    margin-top: 0px;
    text-transform: uppercase;
    text-align: center;
    width: 99%;
    padding: 9px;
    border-radius: 5px;
    min-height: 40px;
    background-color: #60a8dc;
    color: rgb(255, 255, 255);
    border: 1px solid #D9D9D9;
    font-size: 1em;
  }

  .btn_cancel_order {
    cursor: pointer;
    display: block;
    margin: 2px;
    margin-top: 0px;
    text-transform: uppercase;
    text-align: center;
    width: 99%;
    padding: 9px;
    border-radius: 5px;
    min-height: 40px;
    background-color: lightgrey;
    color: black;
    border: 1px solid #D9D9D9;
    font-size: 1em;
  }

  .btn-print {
    cursor: pointer;
    display: block;
    margin: 2px;
    margin-top: 0px;
    text-transform: uppercase;
    text-align: center;
    width: 99%;
    padding: 9px;
    border-radius: 5px;
    min-height: 40px;
    background-color: #60a8dc;
    color: rgb(255, 255, 255);
    border: 1px solid #D9D9D9;
    font-size: 1em;
  }
  .btn-multi-print {
    cursor: pointer;
    display: block;
    margin: 2px;
    margin-top: 0px;
    text-transform: uppercase;
    text-align: center;
    width: 99%;
    padding: 9px;
    border-radius: 5px;
    min-height: 40px;
    background-color: #60a8dc;
    color: rgb(255, 255, 255);
    border: 1px solid #D9D9D9;
    font-size: 1em;
  }
  .pdf-init-info-title {
    font-weight: bold;
    text-align: center;
    font-size: 30px;
    padding-top: 40px;
  }
  .pdf-init-info-footer {
    font-weight: bold;
    text-align: center;
    font-size: 20px;
    padding-top: 10px;
  }
  .pdf-init-info-container {
    text-align: center;
  }
  .pdf-init-info-description {
    font-size: 18px;
    color: rgb(71, 71, 71);
    margin-bottom: 50px;
  }
  .pdf-init-item-header {
    font-size: 14px;
    color: rgb(90, 88, 88);
  }
  .pdf-init-item-info-header {
    font-size: 14px;
    color: rgb(80, 80, 80);
  }
  .pdf-init-info-revpan {
    margin-top: 10px;
    font-size: 24px;
    color: rgb(71, 71, 71);
  }
  .pdf-comparables-container {
    margin-top: 5px;
  }
  .pdf-comparable-filter-container {
    font-size: 24px;
    color: rgb(71, 71, 71);
    padding: 20px;
  }
  .pdf-comparables-table {
    background-color: #f9fafb;
    width: 100%;
    border: 1px solid #d6d6d6;
    font-size: 16px !important;
  }
  .pdf-comparable-table-head {
    text-align: center;
    border-bottom: 1px solid #d0d0d0;
  }
  .pdf-comparable-table-head th {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .pdf-comparable-table-body tr {
    cursor: pointer;
    transition: background-color 0.25s;
    height: 70px;
    border-bottom: 1px solid #d6d6d6;
  }
  .pdf-comparable-table-body tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  .pdf-comparable-table-body tr:hover {
    background-color: rgb(241, 241, 241);
  }
  .pdf-comparable-item-container {
    background-color: white;
    text-align: center;
  }
  .pdf-comparable-image-container {
    position: relative;
    width: 100%;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-right: 10px;
  }
  .pdf-comparable-img {
    width: 60px;
    height: 40px;
    border-radius: 7px;
  }
  .pdf-comparable-distance {
    position: absolute;
    right: 5px;
    top: -7px;
    font-size: 14px !important;
    background-color: #e5e7eb;
    color: black;
    border-radius: 5px;
    padding: 2px 5px;
  }
  .pdf-average-value-title {
    padding-top: 5px;
    padding-left: 40px;
    font-size: 20px;
    color: rgb(71, 71, 71);
  }
  .pdf-average-value-value {
    font-size: 20px;
    font-weight: bold;
  }
  .text-decoration {
    -webkit-text-decoration-line: line-through; /* Safari */
    text-decoration-line: line-through; 
  }


  @media print {
    .pagebreak {
      page-break-before: always;
    }
  }
`;

  useEffect(() => {
    setupSearchList([info]);
  }, [info]);
  var groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  const setupSearchList = (dataList) => {
    let group_data = groupBy(dataList, "table_name");
    var result = [];
    Object.keys(group_data).forEach(function (key) {
      result.push(group_data[key]);
    });
    setSearchList(result);
  };
  const itemUI =
    info.cartList == undefined || info.cartList.length == 0 ? (
      <div>You don't have any Item list</div>
    ) : (
      info.cartList.map((item, index) => {
        return (
          <div key={index}>
            <div
              style={{
                backgroundColor: item.fill_color,
                color: "white",
                padding: 5,
              }}
            >
              <Row gutter={4}>
                <Col>
                  <span className="bold font-14">{item.enter_qty}x</span>
                </Col>
                <Col>
                  <div className="item-name bold font-14">{item.name}</div>
                  <div className="font-15">
                    ${parseFloat(item.total_price).toFixed(2)}&nbsp;
                    {info.payment_currency}
                  </div>
                </Col>
              </Row>
              <div>
                <RecipeExtraItems optionItemString={item.recipe_extra} />
              </div>
              <div>
                <ExtraOptionItems optionItemString={item.extraOptionList} />
              </div>
              <div className="item-note font-14">{item.note}</div>
            </div>
            {info.cartList.length != index + 1 && (
              <div className="item-body-bottom"></div>
            )}
          </div>
        );
      })
    );

  const handleMultiPrintAction = async (pInfo) => {
    let record = pInfo;
    var res = await showMultiPrintDialog({
      title: "Print Multi Recipe",
      info: record,
      isEditing: false,
    });
    if (res === null) return;
    let group_id_list = res.group_id_list;
    let nameList = res.nameList;
    if (group_id_list) {
      let result = [];
      let cartList = pInfo.cartList;
      group_id_list.map((childList, index) => {
        let tmpResult = { ...pInfo };
        let tmpCartList = [];
        let totalBudget = 0;
        let customer_name = "";
        childList.map((info, index) => {
          let person_name_id = info.person_name_id;
          let recipe_id = info.recipe_id;
          customer_name = nameList.filter((x) => x.id === person_name_id)[0]
            .name;
          let cartItem = cartList.filter((x) => x.id === recipe_id)[0];
          totalBudget += parseFloat(cartItem.total_price);
          tmpCartList.push(cartItem);
        });
        tmpResult["cartList"] = tmpCartList;
        tmpResult["customer_name"] = customer_name;
        tmpResult["totalBudget"] = totalBudget;
        result.push([tmpResult]);
      });
      setMultiDataList(result);
    }
    setTimeout(() => {
      handleMultiPrint();
    }, "500");
  };

  const handleSeparatePrintAction = async (pInfo) => {
    let record = pInfo;
    var res = await showSeparatePrintDialog({
      title: "Separate Recipe",
      info: record,
      isEditing: false,
      customer_name:pInfo.customer_name
    });
    if (res === null) return;
    let selectedPrintList = res.selectedPrintList;
    
    if (selectedPrintList) {
      let result = [];
      let cartList = selectedPrintList;
      let tmpResult = {...pInfo};
        let tmpCartList = [];
        let totalBudget = 0;
        let customer_name = res.customer_name;
        selectedPrintList.forEach((info) => {
          const cartItem = cartList.find((x) => x.recipe_id === info.recipe_id);
          if (cartItem) {
            totalBudget += parseFloat(cartItem.total_price || 0);
            tmpCartList.push(cartItem);
          }
        });
        tmpResult["cartList"] = tmpCartList;
        tmpResult["customer_name"] = customer_name;
        tmpResult["totalBudget"] = totalBudget;
        result.push([tmpResult]);
      setMultiDataList(result);
    }
    setTimeout(() => {
      handleMultiPrint();
    }, "500");
  };

  const handleMultiPrint = useReactToPrint({
    content: () => componentMultiRef.current,
  });
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const onChange: CheckboxProps["onChange"] = (e) => {
    selectedOrderAction(info, e.target.checked);
  };
  return (
    <div className="one-item">
      {selectOption && (
        <div style={{ padding: 2 }}>
          <Checkbox onChange={onChange}>Select this order.</Checkbox>
        </div>
      )}
      <div className="item-header font-15">
        {type !== "2" ? (
          <>
            <Row justify="space-between">
              <Col>
                <span className="font-14">
                  No. <span className="font-16">{info.orderIndex}</span>
                </span>
              </Col>
            </Row>
            <Row justify="space-between">
              <Col style={{ paddingRight: 20 }}>
                <span>{info.add_timestamp}</span>
              </Col>
              <Col>
                <p className="customer-name">{info.customer_name}.</p>
              </Col>
            </Row>
          </>
        ) : (
          <Row justify="space-between">
            <Col>
              <span>{info.add_timestamp}</span>
            </Col>
            <Col>
              <p className="customer-name">{info.customer_name}.</p>
            </Col>
          </Row>
        )}
        <Row justify="space-between">
          <Col>
            <span>{info.table_name}</span>
          </Col>
          <Col>
            <span>{info.pay_gateway}</span>
          </Col>
        </Row>
      </div>
      <div className="item-body">{itemUI}</div>
      {type == "0" && (
        <div>
          <button
            className="btn_order_normal"
            onClick={() => {
              approveAction(info);
            }}
          >
            <span>Approve Order</span>
          </button>
          <button
            className="btn_cancel_order"
            onClick={() => {
              cancelAction(info);
            }}
          >
            <span>Cancel Order</span>
          </button>
        </div>
      )}

      {type == "1" && (
        <div>
          <button
            className="btn_order_normal"
            onClick={() => {
              deliverAction(info);
            }}
          >
            <span>Deliver Order</span>
          </button>
          <button
            className="btn_cancel_order"
            onClick={() => {
              cancelAction(info);
            }}
          >
            <span>Cancel Order</span>
          </button>
        </div>
      )}

      {type == "2" &&
        (info.payment_status === null ||
          info.payment_status === undefined ||
          info.payment_status === "") && (
          <button
            className="btn_order_normal"
            onClick={() => {
              paymentConfirmAction(info);
            }}
          >
            <span>Pay Check</span>
          </button>
        )}

      {type == "2" && (
        <button
          className="btn-print"
          onClick={() => {
            handlePrint();
          }}
        >
          <span>
            <PrinterOutlined /> &nbsp;Print Receipt
          </span>
        </button>
      )}

      {/* {type == "2" && (
        <button
          className="btn-multi-print"
          onClick={() => {
            handleMultiPrintAction(info);
          }}
        >
          <span>
            <PrinterOutlined /> &nbsp;Print Multi Receipt
          </span>
        </button>
      )} */}

      {type == "2" && (
        <button
          className="btn-multi-print"
          onClick={() => {
            handleSeparatePrintAction(info);
          }}
        >
          <span>
            <PrinterOutlined /> &nbsp;Separate Receipt
          </span>
        </button>
      )}

      {type === "2" &&
        info.is_receipt_by_email === "1" &&
        validateEmail(info.customer_email) && (
          <button
            className="btn_email_normal"
            onClick={() => {
              const node = componentRef.current;
              const htmlWithStyles = `<style>${emailStyles}</style>${node.innerHTML}`;
              console.log("htmlWithStyles", htmlWithStyles);
              emailReceiptConfirmAction(info, htmlWithStyles);
            }}
          >
            <span>
              <MailOutlined /> &nbsp;EMAIL RECEIPT
            </span>
          </button>
        )}

      <div style={{ display: "none" }}>
        <ComponentToPrint
          ref={componentRef}
          dataList={searchList}
          settingData={settingData}
        />
        <ComponentToMultiPrint
          ref={componentMultiRef}
          dataList={multiDataList}
          settingData={settingData}
        />
      </div>
    </div>
  );
}

export default SaleItemWidget;
